import * as THREE from 'three';
import { baseCommand } from './basecommand'

export type objectDataType = {
    "guid": string;
    "code": string;
    "translate": number[];
    "rotation": number[];
    "scale": number[];
    "layer": any;
    "index": any;
    "reverse": any;
};

export class item extends baseCommand {

    constructor(protected data: THREE.Object3D) {
        super();
    }

    protected objectData(): objectDataType {
        const modelinfo = this.data.userData.modelInfo;
        const position = this.data.getWorldPosition(new THREE.Vector3());
        const scale = this.data.getWorldScale(new THREE.Vector3());

        const modelID = (modelinfo.idthreed && modelinfo.idthreed != '') ? modelinfo.idthreed : modelinfo.code;
        return {
            "guid" : modelinfo.uuid,
            "code": modelID,
            "translate": [position.x, position.y, position.z],
            "rotation": [this.data.rotation.x, this.data.rotation.y, this.data.rotation.z],
            "scale": [scale.x, scale.y, scale.z],
            "layer": modelinfo.layer,
            "index": modelinfo.index,
            "reverse": modelinfo.reverse
        }
    }
}
